/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MachineIdDto } from './machineIdDto';
import { ImplementIdDto } from './implementIdDto';
import { GeometryIdDto } from './geometryIdDto';
import { EmployeeIdDto } from './employeeIdDto';
import { EnterpriseIdDto } from './enterpriseIdDto';

export interface EventV2Dto {
  data?: string;
  employee?: EmployeeIdDto;
  geometry?: GeometryIdDto;
  implement?: ImplementIdDto;
  latitude?: number;
  longitude?: number;
  machine?: MachineIdDto;
  owner?: EnterpriseIdDto;
  time?: string;
  type?: string;
  unit?: string;
}
